<template>
  <div class="side-menu">
    <div class="item">
      <div class="title">规则信息</div>
      <div class="content">
        <div class="content-item">
          <div class="label">规则名称</div>
          <el-input v-model="rule.name" class="value" placeholder="请输入规则名称"></el-input>
        </div>
        <div class="content-item">
          <div class="label">描述</div>
          <el-input
            v-model="rule.desc"
            class="value"
            type="textarea"
            :rows="3"
            placeholder="请输入描述"
          ></el-input>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="title">取数周期</div>
      <div class="content">
        <div class="content-item">
          <div class="label">cron表达式</div>
          <el-input v-model="rule.cron" class="value" placeholder="请输入cron表达式"></el-input>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="title">存储位置</div>
      <div class="content">
        <div class="content-item">
          <div class="label">工作表</div>
          <div class="value edit-sheet">
            <normal-select
              size="small"
              filterable
              :selectList="sheetList"
              :selectedItem.sync="rule.targetSheetId"
              @handle-select="clearFieldMap"
            ></normal-select>
            <template v-if="rule.targetSheetId">
              <el-tooltip content="点击编辑工作表" placement="bottom">
                <div class="icon-tip">
                  <i class="el-icon-link" @click.stop="editSheet"></i>
                </div>
              </el-tooltip>
            </template>
          </div>
        </div>
        <div v-if="rule.targetSheetId && !_.isEmpty(sheetInfo)">
          <div class="content-item">
            <div class="label">取数映射</div>
            <el-button type="text" class="value refresh" @click="refreshSheet">刷新</el-button>
          </div>
          <div v-for="field in mapFields" :key="field.id" class="field-map">
            <div class="field origin" v-tip>{{ "[" + field.group + "] " + field.name }}</div>
            <div class="divide">→</div>
            <normal-select
              size="small"
              class="field"
              :multiple="false"
              :selectList="getOptions(field)"
              :selectedItem.sync="rule.fieldMap[field.id]"
              :key="field.id"
              filterable
            ></normal-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NormalSelect from "@/components/UIComponents/NormalSelect"
import { getSheet } from "@/api/sheet/sheet"

export default {
  name: "side-menu",
  components: { NormalSelect },
  props: {
    rule: Object,
    allSheet: Array,
    controlTypeMap: Object,
    mapFields: Array
  },
  data() {
    return {
      sheetInfo: {}
    }
  },
  computed: {
    sheetList() {
      return this.allSheet.map(i => ({ label: i.name, value: i.sheetId }))
    },
    controlsMap() {
      let allControls = this.getControls()
      return this._.groupBy(allControls, "type")
    }
  },
  watch: {
    "rule.targetSheetId": {
      handler(newVal) {
        this.getSheetInfo()
      }
    }
  },
  methods: {
    getOptions({ id, controlType }) {
      let selectedIds = this.getSelectedIds(id)
      return this.controlsMap[controlType]?.filter(control => !selectedIds.includes(control.value))
    },
    getSelectedIds(id) {
      let result = []
      this.mapFields
        .filter(field => field.id !== id)
        .forEach(field => {
          if (this.rule.fieldMap[field.id]) result.push(this.rule.fieldMap[field.id])
        })
      return result
    },
    getSheetInfo() {
      this.sheetInfo = this.allSheet.find(i => i.sheetId === this.rule.targetSheetId)
    },
    getControls() {
      if (!this.sheetInfo.controls || this.sheetInfo.controls.length <= 0) return []
      return this.sheetInfo.controls
        .concat([
          { name: "创建时间", _cid: "cat", _type: "time" },
          { name: "最后修改时间", _cid: "uat", _type: "time" }
        ])
        .filter(control => ["time", "text", "number"].includes(control._type))
        .reduce((acc, cur) => {
          const typeName = this.controlTypeMap?.[cur._type]?.name
          acc.push({ label: "[" + typeName + "] " + cur.name, value: cur._cid, type: cur._type })
          return acc
        }, [])
    },
    clearFieldMap(sheet) {
      let fieldIds = this.mapFields.map(field => field.id)
      let result = {}
      fieldIds.map(id => (result[id] = null))
      this.rule.fieldMap = result
    },
    refreshSheet() {
      getSheet(this.sheetInfo.sheetId, false).then(res => {
        this.sheetInfo = res
      })
    },
    editSheet() {
      const { href } = this.$router.resolve({
        name: "edit-sheet-field",
        query: { sheetId: this.rule.targetSheetId }
      })
      window.open(href, "_blank")
    }
  }
}
</script>

<style lang="scss" scoped>
.side-menu {
  height: 100%;
  border-left: 2px solid #e4e7ed;
  font-size: 14px;
  padding: 10px;
  .item {
    .title {
      font-weight: 500;
    }
    .content {
      .content-item {
        display: flex;
        margin: 15px 0;
        .label {
          margin-right: 10px;
          width: 72px;
          text-align: right;
        }
        .value {
          flex: 1;
        }
        .refresh {
          padding: unset;
          text-align: left;
        }
      }
    }
    ::v-deep {
      .el-textarea__inner {
        resize: none;
      }
    }
  }
  .field-map {
    display: flex;
    margin: 5px 0 10px 18px;
    align-items: center;
    .divide {
      margin: 0 3px;
    }
    .origin {
      background-color: #f5f5f5;
      padding: 6px 3px;
      border-radius: 4px;
    }
    .field {
      width: 137px;
    }
  }
  .edit-sheet {
    display: flex;
    align-items: center;
    .icon-tip {
      margin-left: 6px;
    }
  }
}
</style>
